<template>
  <div class="container page">
      <van-nav-bar :title="$t('setting.setting')" class="nav-bar setting-nav">
        <template #left>
          <van-icon name="arrow-left" class="nav-back" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="page-body">
      <div class="items">
        <div class="item" @click="toInfomation()">
          <div class="left">{{$t("setting.base_setting")}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item" @click="toLoginPassword()">
          <div class="left">{{$t("setting.login_pwd")}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item" @click="toPayPassword()">
          <div class="left">{{$t("setting.finance_pwd")}}</div>
          <div class="right">
            <span class="desc">{{this.userInfo.paypassword}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item" @click="toLanguage()">
          <div class="left">{{$t("setting.language")}}</div>
          <div class="right">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      </div>
      <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{$t("setting.logout")}}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toPayPassword(){
      if(this.userInfo.paypassword !== this.$t("setting.no_setting")){
        this.$toast(this.$t("withdraw.with_service"));
      }else {
        this.$router.push({path:'/SetPayPassword'});
      }
    },
    toLoginPassword(){
      this.$router.push({path:'/SetLoginPassword'});
    },

    toLanguage(){
      this.$router.push({
        name:'Language',
        params: {
          "type": "setting"
        }
      });
    },
    toInfomation(){
      this.$router.push({path:'/Infomation'});
    },
    loginout(){
        localStorage.clear()
        this.$router.push({path:'/Mine'});
    },
    toServicePage(){
      this.$router.push("ServicePage");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(res.data.paypassword){
            this.userInfo.paypassword = this.$t("setting.y_setting");
          }else {
            this.userInfo.paypassword = this.$t("setting.no_setting");
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  flex: 1;
  padding: 10px 16px 0;
}

.items {
  background-color: #fff;
  font-size: 30px;
}

.item {
  padding: 30px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  border-bottom: 1px solid #ededed;
}

.left {
  color: #000;
}

.right {
  display: flex;
  align-items: center;
}

.desc {
  margin-right: 4px;
  font-size: 30px;
  font-weight: 700;
  color: #9d9d9d;
}

.sign-out {
  width: calc(100% - 32px);
  margin: 140px auto 44px;
  height: 100px;
  line-height: 100px;
  border-radius: 999px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  border: none;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
  box-shadow: none;
}

::v-deep .setting-nav {
  background: #fff;
}

::v-deep .setting-nav .van-nav-bar__title {
  max-width: none;
  color: #000;
  font-weight: 500;
}

::v-deep .setting-nav::after {
  border-bottom: 1px solid #ededed;
}

.nav-back {
  color: #8795ad;
}

::v-deep .item .van-icon {
  color: #9d9d9d;
}
</style>
